import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigLayoutRoutes } from './config-layout.routing';


import { MatPaginatorModule } from '@angular/material/paginator'; 
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import {MatTreeModule} from '@angular/material/tree';
import {MatMenuModule} from '@angular/material/menu';


import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTooltipModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatIconModule,
  MatDatepickerModule,
  MatRadioModule,
  MatCheckboxModule,
  MatListModule,
} from '@angular/material';

import { SharedModule } from '../../shared/shared.module';
import { AmazingTimePickerModule } from "amazing-time-picker";


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ConfigLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    HttpClientModule,
    MatSortModule,
    MatCardModule,
    MatTreeModule,
    MatTabsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    AmazingTimePickerModule,
    MatTableModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatListModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatNativeDateModule,
    SharedModule,
    MatMenuModule,
    
  ],
  exports:[
    MatSortModule,
    AmazingTimePickerModule,
    MatTableModule,
    MatCardModule,
    MatTreeModule,
    MatTabsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatListModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatInputModule,
    MatMenuModule,
    
  ],
  declarations: [
    // SubDashboardComponent,
    // UsuarioComponent,
    // ListaUsuarioComponent,
    // NuevoUsuarioComponent,
    // EmpresaSegComponent,
    // ListadoComponent,
    // NuevoEmpresaComponent,
    // SistemaComponent,
    // ListadoSistemaComponent,
    // NuevoSistemaComponent,
    // RolComponent,
    // ListadoRolComponent,
    // NuevoRolComponent,
    // ComponentesComponent,
    // ListadoComponenteComponent,    
    // NuevoComponenteComponent,
    // ParametroComponent,
    // PermisoComponenteComponent,
    // NuevoParametroComponent, 
    // AccesoComponent,
    // ListadoAccesoComponent,
    // NuevoAccesoComponent,
    // PermisoComponent,
    // ListadoPermisoComponent,
    // NuevoPermisoComponent,
    // UppercaseDirective,
    // GuiasComponent,
    // ListadoGuiaComponent,
    // NuevoGuiaComponent,
    // DetalleGuiaComponent
  ]
})

export class ConfigLayoutModule {}
